import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ChatBubbleSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#chat-bubble-square__a)",
                            children: [
                                _jsx("path", {
                                    d: "M22.601 1.41c-.49-.49-1.14-.76-1.83-.76H4.841a2.597 2.597 0 00-2.59 2.59v14.17l-1.54 4.62c-.12.35-.03.73.21 1 .19.21.46.32.73.32.08 0 .16 0 .24-.03l6.25-1.56h12.61c.69 0 1.34-.27 1.83-.76.48-.48.76-1.15.76-1.83V3.24c0-.69-.27-1.34-.76-1.83h.02zm-1.24 17.75c0 .16-.06.31-.17.42a.59.59 0 01-.42.17H8.031c-.08 0-.16 0-.24.03l-4.6 1.15 1.02-3.05c.03-.1.05-.21.05-.32V3.24c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h15.92c.16 0 .31.06.42.17.11.11.17.26.17.42v15.92z"
                                }),
                                _jsx("path", {
                                    d: "M12.801 9.8c-.37 0-.72.15-.99.41s-.41.62-.41.99.15.73.41.99.61.41.99.41c.37 0 .73-.15.99-.41s.41-.62.41-.99-.15-.73-.41-.99-.62-.41-.99-.41zm-4.37 0c-.37 0-.72.15-.99.41s-.41.62-.41.99.15.73.41.99.61.41.99.41c.37 0 .73-.15.99-.41s.41-.62.41-.99-.15-.72-.41-.99c-.26-.26-.62-.41-.99-.41zm8.75 0c-.37 0-.72.14-.99.41-.26.26-.41.61-.41.99s.14.72.41.99c.26.26.61.4.98.4s.73-.15.99-.41.41-.62.41-.99-.15-.73-.41-.99-.62-.41-.99-.41l.01.01z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "chat-bubble-square__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ChatBubbleSquareIcon.isCarinaIcon = true;
export default ChatBubbleSquareIcon;
